import React from 'react';
import { Switch } from '@components/primitives/Switch';
import { useAppointments } from '@features/appointments';

/**
 * Self-contained toggle component for switching between Calendar and Schedule (List) views
 * Uses internal hooks to manage state - no props needed
 */
export const ScheduleViewToggle: React.FC = () => {
  const { displayMode, setDisplayMode } = useAppointments();

  const handleDisplayToggle = () => {
    setDisplayMode(displayMode === 'calendar' ? 'list' : 'calendar');
  };

  return (
    <Switch
      checked={displayMode === 'list'}
      onChange={handleDisplayToggle}
      label="Schedule View"
      size="medium"
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: '15px',
          color: '#535976',
          lineHeight: 1,
        },
      }}
    />
  );
};

export default ScheduleViewToggle;